import { render } from "./PaymentReceipts.vue?vue&type=template&id=f149d612&scoped=true"
import script from "./PaymentReceipts.vue?vue&type=script&lang=js"
export * from "./PaymentReceipts.vue?vue&type=script&lang=js"

import "./PaymentReceipts.vue?vue&type=style&index=0&id=f149d612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f149d612"]])

export default __exports__